import React, { Fragment } from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import DropdownWithHeader from '../../../../Utils/CommonComponents/DashboardsCommon/DropdownWithHeader'
import { monthlyDropdownList, notificationsCardData } from '../../../../Data/DashboardsData/ECommerceData'
import { NotificationsTitle } from '../../../../Utils/Constants'
import { Btn, H5, Image } from '../../../../AbstractElements'
import { dynamicImage } from '../../../../Utils'
import { Link } from 'react-router-dom'

export default function NotificationsCard() {
    return (
        <Col xl={4} md={6}>
            <Card className="notifications-card">
                <DropdownWithHeader headerClass='pb-0' heading={NotificationsTitle}
                    dropDownClass='icon-dropdown' dropDownIcon dropDownList={monthlyDropdownList} />
                <CardBody>
                    {notificationsCardData.map((item) => (
                        <div className={`d-flex align-items-center ${item.id === 1 ? 'pt-0' : ''}`} key={item.id}>
                            <Image src={dynamicImage(`dashboard-2/user/${item.image}`)} alt="" />
                            <div className="flex-grow-1">
                                <Link to={`${process.env.PUBLIC_URL}/applications/social-app`}>
                                    <H5>
                                        {item.details.map((data, index) => (
                                            <Fragment key={index}>
                                                <strong>{data.name}</strong> {data.text}
                                            </Fragment>
                                        ))}
                                    </H5>
                                    <div className="notification-details">
                                        <span>{item.subText}</span>
                                        <div className="notification-dot" />
                                    </div>
                                </Link>
                            </div>
                            <div className="flex-shrink-0">
                                <Btn color='transparent'>{item.time}</Btn>
                            </div>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </Col>
    )
}